<div class="plan-page__field-container">
    <ProgressBar value={currentTaskNo} max={totalTaskNo} />
    {#if showTag}
        <a
            class="plan-page__field-start-or-continue-link"
            href={getStartOrContinueDestinationLink(taskType)}
            aria-label={computeAriaLabel()}
            on:click={onStartContinueClicked}
        >
            <span>{planHasCompletedTasks ? i18n.continue : i18n.start}</span>
            <span class="plan-page__field-start-or-continue-link--icon" />
        </a>
    {/if}
</div>

<script>
    import i18n from "@its-ui/planner-common/i18n";
    import config from "@its-ui/planner-common/config";
    import ProgressBar from "@its-ui/planner-common/components/ProgressBar/ProgressBar.svelte";
    import { addBackDestinationParam } from "@its-ui/planner-common/helpers/backLinkHelper";
    import { postNewPlannerKpi } from "@its-ui/planner-common/helpers/kpiHelper";
    import { plannerFieldType } from "@its-ui/planner-common/constants";

    export let showTag;
    export let planHasCompletedTasks;
    export let planUrl;
    export let taskType;
    export let nextTask;
    export let currentTaskNo;
    export let totalTaskNo;
    export let fieldType;
    export let backExtraParams = null;

    const getStartOrContinueDestinationLink = () =>
        addBackDestinationParam(`${planUrl}/element/${nextTask.id}/${location.search}`, backExtraParams);

    const computeAriaLabel = () => {
        if (config.useGenericResourceColumn) {
            return planHasCompletedTasks ? i18n.continuePlan : i18n.startPlan;
        } else {
            if (fieldType === plannerFieldType.Activities) {
                return planHasCompletedTasks ? i18n.continueActivities : i18n.startActivities;
            } else {
                return planHasCompletedTasks ? i18n.continueResources : i18n.startResources;
            }
        }
    };

    const onStartContinueClicked = async () => {
        const kpi = planHasCompletedTasks
            ? config.kpi.kpiMeasurementContinueSinglePlanPage
            : config.kpi.kpiMeasurementStartSinglePlanPage;

        await postNewPlannerKpi(kpi);
    };
</script>
